module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-25.53f0fee4.png";